import { P2GBox, P2GChip } from '@parcel2go/core-ui';
import { ClaimRecord, RefundRecord } from '../../../lib/cache/ExtendedOrderCache';
import useGoto from '~/hooks/use-goto';
import { RoutingConstants } from '~/apps/smartsend/lib/consts/RoutingConstants';

interface props {
  claims: ClaimRecord[];
  refunds: RefundRecord[];
  orderlineId: number | string | undefined;
}

export default function ItemRefundAndClaimTagsView(props: props) {
  const { goTo } = useGoto();
  return (
    <P2GBox sx={(t) => ({ display: 'flex', gap: t.spacing(1) })}>
      {props.refunds.map((r, idx) => (
        <P2GChip key={`${r.orderlineId}-${idx}`} color="success" size="small" label={r.status ?? 'Refunded'} />
      ))}
      {props.claims.map((c, idx) => (
        <P2GChip
          onClick={c.id ? () => goTo(`${RoutingConstants.Claims}/${c.id}`) : undefined}
          key={c.id ?? `${c.orderlineId}-${idx}`}
          color="warning"
          size="small"
          label={`Claim: ${c.status}`}
        />
      ))}
    </P2GBox>
  );
}
